Vue.component('media-component', {
    data: function () {
        return {
            id: 'text-media-video'
        }
    },
    mounted: function () {
        this.Video();
    },
    methods: {
        Video: function() {
            let elm = document.querySelector('.text-media video');
            if (elm) {
                let setup = { controls: true, autoplay: false, preload: "auto", muted: false, loop: true };
                let player = videojs(elm, setup, function(){});
                let button = document.querySelector('.text-media__video-trigger');

                button.addEventListener('click', function (e) {
                    player.currentTime(0.1);
                    player.muted(false);
                    player.play();
                });

                player.ready( function() {
                    player.on("play", function () {
                        document.querySelector('.text-media').classList.add('text-media--aspect-video');
                    });

                    player.on("pause", function () {
                        if(player.scrubbing()){
                            document.querySelector('.text-media').classList.add('text-media--aspect-video');
                        } else {
                            document.querySelector('.text-media').classList.remove('text-media--aspect-video');
                        }
                    });

                    player.on("ended", function () {
                        player.pause();

                        if (player.isFullscreen()) {
                            player.exitFullscreen();
                            player.pause();
                        }

                        document.querySelector('.text-media').classList.remove('text-media--aspect-video');
                    });

                    player.on('fullscreenchange', function () {
                        if (player.isFullscreen()) {
                            player.muted(false);
                        } else {
                            player.muted(true);
                        }
                    });
                });
            }
        },
    },
});
